var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:{
    [_vm.$style.token]: true,
    [_vm.$style.token__active]: _vm.active,
    [_vm.$style.token__published]: _vm.isPublishedDoc(_vm.status),
    [_vm.$style.token__draft]: _vm.isDraftDoc(_vm.status),
    [_vm.$style.token__archived]: _vm.isArchivedDoc(_vm.status)
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }